module.exports = getDateTimestamp

function getDateTimestamp (date) {
  if (date) {
    return date
  }

  return new Date().toISOString().substr(0, 10)
}
